<section id="w3l-appointment" class="w3l-form-25 appointment-section form-inner-cont" style="overflow-y: scroll;height: 100%;left: 50px;text-align: center;">

    <BR>

    <div style="display: flex; justify-content: center; width: 100%;">
        <table style="width: 780px;table-layout: fixed;">
            <thead>
                <tr>
                    <th style="background-color:  rgb(70, 70, 247);color: white;width: 15%;height: 5%;">Relation</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white;width: 25%;height: 30%;">Cancer Type</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width: 15%;height: 8%;">Age at Diagnosis</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 8%;">Select</th>

                </tr>
            </thead>
            <tbody>

                <tr *ngFor="let fam of familyhistory; let i = index" style="height: 50%;">
                    <td data-column="Patient ID" style="height: 5%;">{{fam.relation}}</td>
                    <td data-column="Patient Name" style="height: 30%;">{{fam.cancername}}</td>
                    <td data-column="Patient Name" style="height: 10%;">{{fam.age}}</td>
                    <button name="BDrug" placeholder="0" style="width: 100%;height: 35px;" required (click)="SelectFamily(fam)">Select</button>
                </tr>
                <br>
                <div class="styled-input appointment-form-field" style="text-align: center;width: 780px;">
                    <tr>
                        <td style="width: 15%;">
                            <select id="relation" [(ngModel)]="relation" style="background-color: rgb(187, 203, 238);width: 90%;">
                      <option value="Mother">Mother</option>
                      <option value="Father">Father</option>
                      <option value="Brother">Brother</option>
                      <option value="Sister">Sister</option>
                      <option value="Daughter">Daughter</option>
                      <option value="Son">Son</option>
                      <!-- <option value="Aunt">Aunt</option> -->
                      <!-- <option value="Uncle">Uncle</option> -->
                      <!-- <option value="Cousin">Cousin</option> -->
                      <!-- <option value="Niece">Niece</option> -->
                      <option value="Maternal Grandmother">Maternal grandmother</option>
                      <option value="Paternal Grandmother">Paternal grandmother</option>
                      <option value="Maternal GrandFather">Maternal grandFather</option>
                      <option value="Paternal GrandFather">Paternal grandFather</option>
                      <option value="Aunt (maternal)">Aunt (maternal)</option>
                      <option value="Aunt(Paternal)">Aunt(Paternal)</option>
                      <option value="Uncle (Paternal)">Uncle (Paternal)</option>
                      <option value="Uncle (Maternal)">Uncle (Maternal)</option>
                      <option value="Niece">Niece</option>
                      <option value="Nephew">Nephew</option>
                      <option value="Cousin (Paternal)">Cousin (Paternal)</option>
                      <option value="Cousin (Maternal)">Cousin (Maternal)</option>
            </select>
                        </td>
                        <td style="width: 25%;">
                            <select id="itemsgroup" [(ngModel)]="cancerid" style="background-color: rgb(187, 203, 238);width: 90%;">
              <option *ngFor="let itm of cancerList" [value]="itm.cancerID">{{itm.cancerName}}</option>
            </select>
                        </td>
                        <td style="width: 15%;">
                            <input style="width: 90%;" type="textarea" [(ngModel)]="age" />
                        </td>
                        <td style="width: 10%;">
                            <button class="fa fa-floppy-o" style="width: 50%; color: rgb(25, 1, 129);height: 40px;font-size: large;" (click)="submitFHistory()"></button>

                            <button class="fa fa-trash" style="width: 50%; color: red;height: 40px;font-size: large;" (click)="delFHistory_Line()"></button>



                        </td>
                    </tr>
                </div>
            </tbody>
        </table>

    </div>
</section>
<!-- <div class="styled-input">
  
    <div class="appointment-form-field"  style="width: 900px;text-align: center;position: initial">
      <label style="width: 5%;">            </label>
      <select id="relation" name="relation" style="width: 20%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "relation" required>
        <option value="Mother">Mother</option>
        <option value="Father">Father</option>
        <option value="Brother">Brother</option>
        <option value="Sister">Sister</option>
        <option value="Daughter">Daughter</option>
        <option value="Son">Son</option>
        <option value="Aunt">Aunt</option>
        <option value="Uncle">Uncle</option>
        <option value="Cousin">Cousin</option>
        <option value="Niece">Niece</option>
        <option value="Maternal Grandmather">Maternal grandmather</option>
        <option value="Paternal Grandmather">Paternal grandmather</option>
        <option value="Maternla GrandFather">Maternla grandFather</option>
        <option value="Paternal GrandFather">Paternal grandFather</option>
        <option value="Aunt (maternal)">Aunt (maternal)</option>
        <option value="Aunt(Paternal)">Aunt(Paternal)</option>
        <option value="Uncle (Paternal)">Uncle (Paternal)</option>
        <option value="Uncle (Maternal)">Uncle (Maternal)</option>
        <option value="Niece">Niece</option>
        <option value="Nephew">Nephew</option>
        <option value="First Cousin (Paternal)">First Cousin (Paternal)</option>
        <option value="First Cousin (Maternal)">First Cousin (Maternal)</option>

    </select>
      <select id="itemsgroup" name="itemsgroup" required=""  style="width: 33%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "cancerid" >
        <option value="{{itm.cancerID}}"  *ngFor="let itm of cancerList; let i = index">{{itm.cancerName}}</option>
      </select>
      <input type="textarea" name="DoctorOperation" placeholder="0" [(ngModel)]= "age" required="" style="width: 20.5%;"/>
      <button name="BDrug_00" class="fa fa-floppy-o"  style="width: 6.5%;height: 100%;color: rgb(25, 1, 129);"  (click)="submitFHistory()"></button>
      <label style="width:.3%"></label>
      <button name="BDrug_11"  class="fa fa-trash"  style="width: 6.5%;height: 100%;color: red;"  (click)="delFHistory_Line()"></button>
    </div>
</div> -->
